
<div class="review-dialog">
  <!-- <h1 mat-dialog-title> {{isReply ? "Nouvelle revue"  : "Repondre " }}</h1>
  <h1 mat-dialog-title> Statut: {{data.status }}</h1> -->

  <div mat-dialog-content class="review">
    @if ((data.id==='')) {
      <form #reviewForm="ngForm" class="review-form">
        <div class="form-line">
          <br />
          <span >Votre note:&nbsp;&nbsp;
            @for (r of userRatingIndicators; track r; let i = $index) {
              <span (click)="data.rate = i+1;">
                <!--<mat-icon>star_outlined</mat-icon>
                <mat-icon *ngIf="r===1">star</mat-icon> -->
                <mat-icon class="rate-icon" > {{data.rate>i ?'star':'star_outlined'}}</mat-icon>
              </span>
            }
            ({{data.rate}})
          </span>
        </div>
        <br />
        <div class="form-line">
          <mat-form-field>
            <mat-label>Commentaire</mat-label>
            <textarea type="text" required matInput="" name ="comment" placeholder=""  [(ngModel)]="data.comment" ></textarea>
          </mat-form-field>
        </div>
        @if ((loggedInUserId$ | async)! ==='') {
          <div >
            <mat-form-field >
              <mat-label>Email</mat-label>
              <input type="email" required matInput="" name ="email" placeholder=""  [(ngModel)]="data.raterEmail" >
            </mat-form-field>
          </div>
        }
        <div class="form-line">
          @if ((loggedInUserId$ | async)! ==='') {
            <mat-form-field class="half-line">
              <mat-label>Nom</mat-label>
              <input type="text" required matInput="" name ="name" placeholder=""  [(ngModel)]="data.raterName" >
            </mat-form-field>
          }
          <mat-checkbox class="half-line" mat-input="" name ="nameIsPublic" [(ngModel)]="data.nameIsPublic">
            <h6>Publier votre nom</h6>
          </mat-checkbox>
        </div>
        @if ((loggedInUserId$ | async)! ==='') {
          <div class="form-line">
            <mat-form-field class="half-line">
              <mat-label>Pays</mat-label>
              <input type="text" required matInput="" name ="country" placeholder=""  [(ngModel)]="data.country" >
            </mat-form-field>
            @if ((loggedInUserId$ | async)! ==='') {
              <mat-form-field class="half-line">
                <mat-label>Ville</mat-label>
                <input type="text" required matInput="" name ="city" placeholder=""  [(ngModel)]="data.city" >
              </mat-form-field>
            }
          </div>
        }
        <div class="action-buttons">
          <button class="simple-button-buy" mat-button [mat-dialog-close]="">Annuler</button>
          <button class="cta-button-buy" mat-button  [disabled]="(!reviewForm.valid || data.rate ==0)" [mat-dialog-close]="data">
            Poster
          </button>
        </div>
      </form>
    }

    @if (!(data.id==='')) {
      <form #replyForm="ngForm" class="review-form">
        <h6> Nom: <b>{{data.raterName}}</b></h6>
        <h6> Commentaire: <b>{{data.comment}}</b></h6>
        <br />
        <div class="form-line">
          <mat-form-field>
            <mat-label>Réponse</mat-label>
            <textarea type="text" required matInput="" name ="newReply" placeholder=""  [(ngModel)]="data.newReply.comment" ></textarea>
          </mat-form-field>
        </div>
        <div class="action-buttons">
          <button class="simple-button-buy" mat-button [mat-dialog-close]="">Annuler</button>
          <button class="cta-button-buy" mat-button  [disabled]="(!replyForm.valid)" [mat-dialog-close]="data">
            Poster
          </button>
        </div>
      </form>
    }

  </div>

  <!-- <div mat-dialog-actions class="review-reply">

  <mat-form-field>
    <textarea  matInput type="text"  name="reply" placeholder="Répondre"  [(ngModel)]="data.reply.body" ></textarea>
  </mat-form-field>

  <button [disabled]="data.reply.body ===''" matButton class="cta-button"  mat-button [mat-dialog-close]="data" >
    <mat-icon>send</mat-icon>
  </button>

</div> -->


</div>
